<template>
  <div class="box">
    <div class="comments">
      <v-list-item v-if="!canHaveComment" v-bind:key="index">
        <v-list-item-content>
          <v-list-item-title class="font-s text-gray px-5 pt-10 text-center">Bitte wählen Sie ein
            Element aus</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list v-if="canHaveComment" three-line>
        <v-list-item-title v-if="canHaveComment && comments.length == 0"
                           class="font-s text-gray px-5 pt-10 text-center">
          Es gibt noch keinen Kommentar
        </v-list-item-title>
        <template v-for="(comment, index) in comments">
          <v-list-item v-bind:key="index" class="border-bottom">
            <v-list-item-content class="mt-2">
              <v-list-item-title v-html="highlightLinks(comment.text)"></v-list-item-title>
              <v-list-item-subtitle>
                <p class="mt-2">
                  <span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="cursor-default" v-bind="attrs" v-on="on">
                          <v-avatar
                              color="gray_2"
                              size="24"
                              style="color: #fff; font-size: 12px;"
                          >{{initials(comment.userId)}}</v-avatar>
                        </span>
                      </template>
                      <span>{{ comment.userId }}</span>
                    </v-tooltip>
                  </span>
                  <v-icon small>mdi-circle-small</v-icon>
                  <span class="sub cursor-default">{{comment.createdDate | moment("DD.MM.YYYY HH:mm")}}</span>
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon @click="deleteComment(comment.id)" class="pointer">
                <v-icon color="gray" medium>mdi-delete</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </template>
   
      </v-list>
    </div>

    <div v-if="canHaveComment" class="newComment">
      <div style="position: absolute; left: 25px; bottom:0; top: 25px; right: 75px;">
        <v-text-field v-model="commentText" label="Neuer Kommentar" outlined></v-text-field>
      </div>
      <div style="position: absolute; right: 0; bottom:0; top: 30px; width: 75px;">
        <v-btn @click="saveComment" class="mx-2" fab dark small color="primary">
          <v-icon dark>mdi-send</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import commentService from "./comment-service";

export default {
  components: {},
  props: {
    uuid: String,
    elementId: String,
  },
  data: function() {
    return {
      commentText: '',
      comments: [],
      canHaveComment: true
    };
  },
  mounted: function() {
    if(this.elementId.includes("Collaboration") || (this.elementId.includes("Process") && !this.elementId.includes("Sub"))) {
      this.canHaveComment = false;
    }else{
      this.retrieveComments();
      this.canHaveComment = true;
    }
  },
  watch: {
    elementId: function(val) {
      if(this.elementId.includes("Collaboration") || (this.elementId.includes("Process") && !this.elementId.includes("Sub"))) {
        this.canHaveComment = false;
      }else{
        this.retrieveComments();
        this.canHaveComment = true;
      }
    }
  },
  computed: {},
  methods: {
    saveComment(){
      commentService.saveComment(this.uuid, this.elementId, this.commentText).then(()=>{
        this.commentText ='';
        this.retrieveComments();
        this.$emit("refresh");
      });
    },
    retrieveComments(){
      commentService.retrieveComments(this.uuid, this.elementId).then(result =>{
        this.comments = result.data;
      });
    },
    deleteComment(id){
      commentService.deleteComment(id).then(()=> {
        if(this.comments.length == 1){
          this.$emit("refresh");
        }
        this.retrieveComments();
      })
    },
    initials(email){
      let initials = email.substring(0,2).toUpperCase();
      return initials;
    },
    highlightLinks(text) {
      // Regular expression to match URLs
      const urlRegex = /((http|https):\/\/[^\s]+)/g;

      // Replace URLs with anchor tags
      const highlightedText = text.replace(urlRegex, '<a href="$&" target="_blank">$&</a>');

      return highlightedText;
    },
  }
};
</script>
<style scoped>
.comments,
.newComment {
  position: absolute;
}
.comments {
  top: 0;
  left: 0;
  right: 0;
  bottom: 100px;
  overflow-y: auto;
}
.newComment {
  bottom: 0;
  right: 0;
  left: 0;
  height: 100px;
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.sub {
  font-size: 0.7rem;
}
</style>